var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"list-toggle",class:{ 'list-toggle--active': _vm.isFollowed },on:{"click":_setup.onFollowToggle}},[_c('FontAwesomeIcon',{attrs:{"icon":_setup.faBookmark}}),_c('span',{staticClass:"button-label"},[_vm._v(_vm._s(_vm.isFollowed ? _vm.$tc('WEBAPP_UNFOLLOW') : _vm.$tc('WEBAPP_FOLLOW')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }